import trafficIndex from '@/views/traffic/trafficIndex.vue'
import lineIndex from '@/views/traffic/line/index.vue'
import carIndex from '@/views/traffic/car/index.vue'
import voteIndex from '@/views/traffic/vote/index.vue'
import codeIndex from '@/views/traffic/code/index.vue'
import trainIndex from '@/views/traffic/train/index.vue'
import aircraftIndex from '@/views/traffic/aircraft/index.vue'

export default {
  path: '/traffic',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
    {
      path: 'trafficIndex',
      name: 'trafficIndex',
      component: trafficIndex
    },

    // 手机查路线页面
    {
      path: 'line/index',
      name: 'lineIndex',
      component: lineIndex
    },
    // 手机打车页面
    {
      path: 'car/index',
      name: 'carIndex',
      component: carIndex
    },
    // 手机买票页面
    {
      path: 'vote/index',
      name: 'voteIndex',
      component: voteIndex
    },
    // 乘车码调用页面
    {
      path: 'code/index',
      name: 'codeIndex',
      component: codeIndex
    },
    //买火车票
    {
      path: 'train/index',
      name: 'trainIndex',
      component : trainIndex
    },
    //买飞机票
    {
      path: 'aircraft/index',
      name: 'aircraftIndex',
      component : aircraftIndex
    },
  ]
}
